export function Loader({ loaded, children, style = {} }) {
    if (loaded) {
        if (children) {
            return children;
        }
        return (<div style={{ display: "none" }} />);
    }
    
    return (
        <div style={style} className="loading-spinner-wrapper flex">
            <span className="loading-spinner">
                <i className="one" /><i className="two" /><i className="three" />
            </span>
        </div>
    );
}
